import { writable } from "svelte/store"

/**
 * Represents a document object.
 * @class
 */
export class alias {
  /**
   * Constructs a new alias instance.
   * @constructor
   */
  constructor() {
    /**
     *selected document id's proposed URL.
     * @type {number}
     * @default 0
     */
    this.proposedURL = 0
  }
}

/**
 * @type {DocumentAccessControl} - Retrieving the alias data from local storage
 */
let stats = localStorage.getItem("P2BAlias")

if (typeof stats != "Object") {
  try {
    // Parsing the value as JSON
    stats = JSON.parse(stats)
    if (!stats) {
      // Throwing an error if the parsed value is null
      throw new Error("Document value is null")
    }
  } catch (error) {
    // Initializing stats with a new instance of the alias object class
    stats = new alias()
  }
}

/**
 * @typedef {Object} DocumentAccessControl - alias page stats.
 * @type {Object}
 * single publisg stats.
 * 
 * @property {String} proposedURL - selected document id's proposed URL.
 * /
 
/**
 * @type {import("svelte/store").Writable<DocumentAccessControl>}
 */

const DocumentAccessControl = writable(stats)

/**
 * Updates the value of "P2BAlias" in the localStorage.
 * @param {object} stats - The stats object to be stored.
 */
export const updateAlias = (stats) => {
  // Stringify the stats object and store it in the localStorage
  localStorage.setItem("P2BAlias", JSON.stringify(stats))
}
export default DocumentAccessControl
